export default __webpack_public_path__ + "media/empty/empty-contacts-e51ebd66.jpg";